import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAi = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 24,
			r: 8,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 24,
			r: 2,
			fill: "currentColor",
			opacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 6v10M24 32v10M6 24h10M32 24h10",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			opacity: .35
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7 12.7l7 7M28.3 28.3l7 7M35.3 12.7l-7 7M19.7 28.3l-7 7",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinecap: "round",
			opacity: .2
		})
	]
});
export default SvgAi;
